import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { PregnancyMeasurementPageContent } from "@madmedical/ui";
import { MetricType } from "@madmedical/medical";
import { useMe } from "@madmedical/user";
import PregnancyMeasurementModalForm from "./PregnancyMeasurementModalForm";
import PregnancyProviderWrapper from "./PregnancyProviderWrapper";
var ModalState;
(function (ModalState) {
    ModalState[ModalState["Closed"] = 0] = "Closed";
    ModalState[ModalState["Measure"] = 1] = "Measure";
    ModalState[ModalState["Feeling"] = 2] = "Feeling";
    ModalState[ModalState["Edit"] = 3] = "Edit";
    ModalState[ModalState["Delete"] = 4] = "Delete";
})(ModalState || (ModalState = {}));
const PregnancyMeasurementPage = () => {
    const { roles: { isDoctor }, } = useMe();
    /*
    const { patientId } = usePatientId();
    */
    const [modal, setModal] = useState(ModalState.Closed);
    const [measurementType, setMeasurementType] = useState("weight");
    const handleMeasurePress = (type) => {
        setModal(ModalState.Measure);
        setMeasurementType(type);
    };
    const handleModalClose = () => {
        setModal(ModalState.Closed);
    };
    return (_jsx(_Fragment, { children: _jsxs(PregnancyProviderWrapper, Object.assign({ setModal: setModal }, { children: [_jsx(PregnancyMeasurementPageContent, { onMeasurePress: handleMeasurePress, isDoctor: isDoctor }), _jsx(PregnancyMeasurementModalForm, { metricType: measurementType === "weight"
                        ? MetricType.BodyWeight
                        : MetricType.AbdominalCircumference, open: modal === ModalState.Measure, onClose: handleModalClose })] })) }));
};
export default PregnancyMeasurementPage;
